import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchSignNowEnvelopeQuery,
  Flex_FetchSignNowEnvelopeQueryVariables,
} from '~/typings/graphql';
import { SignNowEnvelopeStatus } from '~/typings/signnow';
import { FETCH_SIGN_NOW_ENVELOPE } from './fetch-signnow-envelope.queries';

interface FetchSignNowEnvelopeParams {
  envelopeId: number;
}

export interface FetchSignNowEnvelopeResponse {
  status: SignNowEnvelopeStatus;
  envelope: {
    id: number;
    url?: string | null;
    inviteExpiresAt?: string | null;
  };
}

export const fetchSignNowEnvelope = async (
  params: FetchSignNowEnvelopeParams,
): Promise<FetchSignNowEnvelopeResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchSignNowEnvelopeQuery,
    Flex_FetchSignNowEnvelopeQueryVariables
  >({
    fetchPolicy: 'no-cache',
    query: FETCH_SIGN_NOW_ENVELOPE,
    variables: {
      id: params.envelopeId,
    },
  });

  if (!data?.signNowEnvelope) {
    throw new Error('Failed to fetch SignNow envelope');
  }

  const envelope = data.signNowEnvelope;

  return {
    status: envelope.status as SignNowEnvelopeStatus,
    envelope: {
      id: envelope.id,
      url: envelope.signingUrl,
      inviteExpiresAt: envelope.inviteExpiresAt,
    },
  };
};
